module.exports = __webpack_public_path__ + "static/media/DLF - Gradiente Logo Branco.39d1fad7.svg";